// ** Router Import
import React, { useEffect } from 'react'
import Router from "./router/Router";
// import withSession from "./ui/components/Session/withSession";


const App = () => {
    const user = localStorage.getItem("UserRes") && JSON.parse(localStorage.getItem("UserRes"))
    useEffect(() => {
        if (window && user?.EMAIL_ID_OFF && window?.location?.hostname !== "localhost") {
            console.log("clarity called")
            window.clarity("identify", user?.EMAIL_ID_OFF)
        }
    }, [user?.EMAIL_ID_OFF])

    return (
        <Router />
    )
}

// export default withSession(App);
export default App;

